// @flow

import React, { type AbstractComponent } from 'react';
import ExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';
import PropTypes from 'prop-types';
import type AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';
import { useRequestContext } from 'app/common/react/components/RequestContext';

export type Experiments = AExperimentsClient;

export const ExperimentsPropType = PropTypes.instanceOf(ExperimentsClient);

type InjectedProps = { experiments: Experiments };

export default function LegacyWithExperiments<OwnProps: InjectedProps>(
  Subject: AbstractComponent<OwnProps>,
): AbstractComponent<$Diff<OwnProps, InjectedProps>> {
  function WithExperiments(props) {
    const { experiments } = useRequestContext();
    return <Subject experiments={experiments} {...props} />;
  }

  WithExperiments.displayName = `WithExperiments(${String(Subject.displayName || Subject.name)})`;
  return WithExperiments;
}
